import { useState } from "react"

export const useDate = () => {
  const [date, setDate] = useState<Date | null>(null)
  const changeDate = (d: Date) => setDate(d)

  return { date, changeDate }
}
